import { memo } from 'react'

import { appConfig } from 'config/app'

import { CookieYesProps } from '.'

function CookieYes({ cbid }: CookieYesProps): JSX.Element {
  if (!cbid || appConfig.appEnv !== 'production') return <></>
  if (typeof window === 'undefined') {
    return <></>
  }
  if (!cbid || !document) {
    return <></>
  }

  if (cbid.length !== 24) {
    console.warn(
      `The cookie bot domain group id is ${cbid.length} characters, instead it should be 36 characters!`,
    ) // eslint-disable-line no-console
  }

  const script = document.createElement('script')
  script.setAttribute('id', 'cookieyes')
  script.setAttribute('src', `https://cdn-cookieyes.com/client_data/${cbid}/script.js`)
  script.setAttribute('data-blockingmode', 'auto')
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('strategy', 'beforeInteractive')
  const head = document.querySelector('html > head')

  if (head) {
    head.insertBefore(script, head.firstChild)
  }

  return <></>
}

export default memo(CookieYes)
